export const getDesignationMasterList = state => {
    return state.list
}

export const getDesignationMasterDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/designationMaster/getters.js